<div class="login-v2">
  <div class="bg-streaks"></div>
  <div class="bg-skyline"></div>
  <div class="bg-glow"></div>

  <header class="topbar">
    <img class="logo-img" src="assets/images/logo-new-05-2025.png" alt="INSEE Life Insurance" />
    <div class="lang">
      <button type="button" [class.on]="isLao" (click)="switchLang('lo')">ລາວ</button>
      <button type="button" [class.on]="!isLao" (click)="switchLang('en')">EN</button>
    </div>
  </header>

  <div class="shell">

    <!-- LEFT: slogan -->
    <section class="stage-left">
      <div class="slogan">
        <span class="eyebrow">Life Insurance · Laos</span>
        <h1>ຊີວິດດີໆ <span class="g">ທີ່ໃຜ</span> ກໍມີໄດ້</h1>
        <h2>ອິນຊີ ປະກັນຊີວິດ</h2>
        <div class="trust">
          <span class="tchip"><i class="fa-solid fa-shield-halved"></i>ປອດໄພ ໝັ້ນຄົງ</span>
          <span class="tchip"><i class="fa-regular fa-clock"></i>ບໍລິການ 24 ຊົ່ວໂມງ</span>
        </div>
      </div>
    </section>

    <!-- RIGHT: login card -->
    <section class="login-card">
      <div class="mark">
        <img class="logo-img" src="assets/images/logo-new-05-2025.png" alt="INSEE Life Insurance" />
      </div>

      <div class="welcome">
        <h3>{{ 'AUTH.WELCOME' | translate }}</h3>
        <p>{{ 'AUTH.WELCOME_SUB' | translate }}</p>
      </div>

      <div *ngIf="showLoginError" class="err" role="alert" aria-live="assertive">
        <i class="fa-solid fa-circle-exclamation"></i>
        <span>{{ loginError }}</span>
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="login()">
        <div class="field">
          <label for="username">{{ 'AUTH.USERNAME' | translate }}</label>
          <div class="input">
            <span class="lead"><i class="fa-regular fa-user"></i></span>
            <input
              id="username"
              name="username"
              type="text"
              autocomplete="username"
              [placeholder]="'AUTH.USERNAME_PLACEHOLDER' | translate"
              formControlName="username"
              required
            />
          </div>
        </div>

        <div class="field">
          <label for="password">{{ 'AUTH.PASSWORD' | translate }}</label>
          <div class="input">
            <span class="lead"><i class="fa-solid fa-lock"></i></span>
            <input
              id="password"
              name="password"
              [type]="showPassword ? 'text' : 'password'"
              autocomplete="current-password"
              [placeholder]="'AUTH.PASSWORD_PLACEHOLDER' | translate"
              formControlName="password"
              required
            />
            <button
              type="button"
              class="eye"
              tabindex="-1"
              [attr.aria-label]="'AUTH.TOGGLE_PASSWORD' | translate"
              (click)="showPassword = !showPassword"
            >
              <i class="fa-solid" [class.fa-eye-slash]="showPassword" [class.fa-eye]="!showPassword"></i>
            </button>
          </div>
        </div>

        <button class="btn-login" type="submit" [disabled]="isLoading">
          <ng-container *ngIf="isLoading; else loginLabel">
            <span class="spin" role="status" aria-hidden="true"></span>
            <span>{{ 'COMMON.LOGIN' | translate }}</span>
          </ng-container>
          <ng-template #loginLabel>
            <span>{{ 'COMMON.LOGIN' | translate }}</span>
            <i class="fa-solid fa-arrow-right"></i>
          </ng-template>
        </button>
      </form>

      <p class="help">
        {{ 'AUTH.NEED_HELP' | translate }} <a>{{ 'AUTH.CONTACT_ADMIN' | translate }}</a>
      </p>
    </section>
  </div>

  <div class="foot">© 2026 INSEE Life Insurance Co., Ltd. · ສະຫງວນລິຂະສິດທຸກປະການ</div>
</div>
